export default class Mobile {
    constructor(element) {
        this.header = element;
        this.open = this.header.querySelector('.header-nav-mobile-open');
        this.close = this.header.querySelector('.header-nav-mobile-close');

        this.open.addEventListener('click', () => this.openMobileNavigation());
        this.close.addEventListener('click', () => this.closeMobileNavigation());
    }

    openMobileNavigation() {
        this.header.classList.remove("collapsed");
        document.querySelector('body').classList.add('noscroll');
    }

    closeMobileNavigation() {
        this.header.classList.add("collapsed");
        document.querySelector('body').classList.remove('noscroll');
    }
}